import { createApp } from 'vue';
// import { createPinia } from 'pinia';
import FavouriteIcon from './favourites/components/FavouriteIcon.vue';
import FavouriteCount from './favourites/components/FavouritesCount.vue';
// import FavouritesMap from "./favourites/components/FavouritesMap.vue";
import FavouritesList from "./favourites/components/FavouritesList.vue";

// init fav buttons
const favButtons = document.querySelectorAll('.js-fav-button');
favButtons.forEach((favButton) => {
    const { id, type, classes } = favButton.dataset;
    const cssClasses = classes ? classes.split(' ') : [];
    createApp(
        FavouriteIcon,
        {
            id,
            type,
            cssClasses
        }
    ).mount(favButton);
})


// init favourites count
const favCountItems = document.querySelectorAll('.js-fav-count');
favCountItems.forEach((favCount) => {
    createApp(FavouriteCount).mount(favCount);
})

// const favMap = document.getElementById('favourites-map');
// if (favMap) {
//     const pinia = createPinia();
//     const app = createApp(FavouritesMap);
//
//     app.use(pinia);
//     app.mount(favMap);
// }

const favList = document.getElementById('favourites-list');
if (favList) {
    let itemsPerPage = favList.getAttribute('data-page-size');
    itemsPerPage = 12;
    createApp(FavouritesList, { itemsPerPage }).mount(favList);
}
